import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { MeliServices } from 'src/app/services/meli.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

@Component({
    selector: 'app-catalogo',
    templateUrl: './catalogo.component.html',
    styleUrls: ['./catalogo.component.scss'],
    standalone: false
})
export class CatalogoComponent implements OnInit {

  cols = 1;
  products:Object[] = [];
  codeCompany: any;
  codeProduct: any;
  mlb_anuncio: any;
  inputData="";
  columns:{colid:number,mlb:string,children_ids:object[],parent_id:string,catalog_product_id:string,data:any[]}[] = [];
  codeMeli: number;
  codeContract: number;
  
    //@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) { }

  constructor(@Inject(MAT_DIALOG_DATA) public data, 
       public dialogRef:MatDialogRef<any>,
       private snackBar:SnackbarService, 
       private meliservices:MeliServices, 
       private spinner:NgxSpinnerService, 
       private dialogService:DialogService, 
       public ThemeService:ThemeService,
       private http:HTTPService) { }

  ngOnInit(): void {
      // this.codeCompany = 201;//this.data['CODECOMPANY'];
      // this.codeProduct = 15076/// this.data['CODEPRODUCT'];
      // this.codeMeli = 1/// this.data['CODEPRODUCT'];
      // this.codeContract = 1/// this.data['CODEPRODUCT'];
      // this.mlb_anuncio = 'MLB2757993314';//this.data['MLB_ANUNCIO'];
      this.codeCompany = this.data['CODECOMPANY'];
      this.codeProduct = this.data['CODEPRODUCT'];
      this.codeMeli = this.data['CODEMELI'];
      this.codeContract = this.data['CODECONTRACT'];
      this.mlb_anuncio = this.data['MLB_ANUNCIO'];
      this.getProductData(true);
    
  }



  buscar(){
    if ( this.inputData && this.inputData!=''){
      this.columns = [];
      this.getProductData(false);  
    }  
  }

  buscarEnter(evento:KeyboardEvent){
    
    if ( evento.key == "Enter" ){
      this.buscar();  
    }
  }

  getProductData(byId:boolean){ 
    this.spinner.show();
    
    this.meliservices.getAnuncio(this.mlb_anuncio, this.codeCompany).then(data=>{
      let identifier = byId ? this.findIdentifier(data) : null;
      
      this.meliservices.getProdutoCatalogo(this.inputData,this.codeCompany,identifier).then(prods=>{
          if (prods['results']){
            this.mountData(data,prods['results']);
          }
          this.spinner.hide();
        }).catch((error)=>{
            this.spinner.hide();
            setTimeout(function() { throw  error; });
        })
      
    }).catch((error)=>{
      this.spinner.hide();
      setTimeout(function() { throw  error; });
    });
      
  }

  mountData(data,prods){
      
      let attrib:Object[] = data['attributes'];
      //criando linha zero com dados do produto
      let col = {
          colid: 0,
          mlb: '0',
          catalog_product_id:"",
          children_ids:[],
          parent_id:"",
          data: []
      }

      let col2 = {
        colid: 1,
        mlb: data['id'],
        catalog_product_id:"",
        children_ids:[],
        parent_id:"",
        data: []
    }

      col.data.push({name:'Imagens'});
      col2.data.push({name:data['pictures']});
      col.data.push({name:'Título'});
      col2.data.push({name:data['title']});

      if ( attrib ){
        attrib.forEach(x=>{
          if ( x['value_name'] != null ){
            col.data.push({name:x['name']});
            col2.data.push({name:x['value_name']});
          }
        });
      }
      

      this.columns.push(col);
      this.columns.push(col2);
      
      let colId = 3;
      (prods as Object[]).forEach( prod=>{
          let obMatch = {
              colid: colId,
              mlb: col2.mlb,
              children_ids:prod['children_ids'],
              parent_id:prod['parent_id'],
              catalog_product_id:prod['id'],
              data: []
          }

          let obMatchData:Object[] = [];
          obMatchData.push({name:prod['pictures']});
          obMatchData.push({name:prod['name']});
          
          let attribs:Object[]  = prod['attributes'];

          col.data.filter(data=> data.name !='Título' && data.name!='Imagens').forEach( n=>{
              let attrib = attribs.find(tt=>tt['name']==n['name'])
              if ( attrib){
                  obMatchData.push({name:attrib['value_name']});
              }else{
                obMatchData.push({name:"N/A"});
              }
          })

          obMatch['data'] = obMatchData;

          this.columns.push(obMatch);

          colId++;
      });
  }

  getSize(tipo:string){
    if ( this.columns[0] == null){
      return;
    }
    
    if ( tipo == 'H'){
      return ((this.columns[0].data.length  * 65)+65)+"px"; 
    }

    if ( tipo == 'W'){
      return (this.columns.length * 300)+"px";
    }
  }


  async saveData(catalog) {
    await new Promise((resolve, reject) => {
      let jsonSave: Object = {
        entityName: "Mktpmeli",
        CODECOMPANY: this.codeCompany,
        CODEPRODUCT: this.codeProduct,
        CODECONTRACT: this.codeContract,
        CODEMELI: this.codeMeli,
        CATALOGPRODUCTID: catalog
      };

      this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe(data=>{
        resolve(data);
        }    
      );
    });
  }


  selectData(item){

      if ( item.colid <= 1 ){
        return;
      }

      this.spinner.show();

      this.dialogService.title = "Vincular Catálogo";
      this.dialogService.openNewDialog('Será vinculado ao catálogo selecionado. Deseja continuar?',(data)=>{
        
        this.meliservices.vincularCatalogo(item,this.codeCompany).then(data=>{
            this.saveData(item['catalog_product_id']).then(data=>{
              this.snackBar.showSuccess("Produto vinculado com sucesso.");
              this.spinner.hide();
            }).catch(error=>{
              this.spinner.hide();
              setTimeout(function() { throw  error; });
            });
        }).catch(error=>{
          this.spinner.hide();
            if ( error instanceof HttpErrorResponse ){
              if ( error.error){
                if ( error.error.message){
                  if ( error.error.message.toString().indexOf('A catalog listing has already')>-1){
                    setTimeout(function() { throw  new Error('Produto já está vinculado a um catálogo.'); });
                    return;
                  }
                }
              }
            }
            setTimeout(function() { throw  error; });
            
        })
         
      });
      
  }

  findIdentifier(data: Object) {

      if ( data['attributes']){
        let attrib:Object[] = data['attributes'];
        let gtin = attrib.find(d=>d['id']=='GTIN');

        if ( gtin ){
          if ( gtin['value_name']){
            return gtin['value_name'];
          }
        }
      }
      return null;
  }
  
}

